/*
  doc_loading.js allows css and js to know when the page has loaded
 */
$(document).ready(docLoading);

// docLoading removes 'doc_loading' class from body to unable css transitions and avoid flickering
function docLoading() {
  setTimeout(() => {
    $('body').removeClass('doc_loading');
  }, 0);

  // maintain the layout query param upon page navigation
  const { layout } = zr.page.model;

  if (layout !== '' && layout !== null) {
    const sectionsToLayout = $('.dirp_variant .search_anchor,.dirp_variant .breadcrumb_item:last-child,.related_links,.related_links_2, .load_more');

    for (let fs = sectionsToLayout.find('form'), numForms = fs.length, i = 0; i < numForms; i++) {
      $('<input />').attr('type', 'hidden')
        .attr('name', 'layout')
        .attr('value', layout)
        .appendTo(fs[i]);
    }

    for (let ls = sectionsToLayout.find('a'), numLinks = ls.length, i = 0; i < numLinks; i++) {
      const url = new URL(ls[i].href);
      url.searchParams.append('layout', layout);
      ls[i].href = url;
    }
  }
}
